import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { PrimeDropdownControl } from 'app/shared/dynamic-forms/form-models/prime-dropdown-control';
import { PrimeNGConfig } from 'primeng/api';

@Component({
  selector: 'hb-df-prime-dropdown',
  templateUrl: './prime-dropdown.component.html',
  styleUrls: ['./dropdown-style.scss'],
})
export class PrimeDropdownComponent implements OnInit{
  @Input() public control: PrimeDropdownControl;
  @Input() public formGroup: FormGroup;

  @Output() public onOverrideValue = new EventEmitter();

  constructor(private primengConfig: PrimeNGConfig) {}

  public ngOnInit(): void {

    this.primengConfig.overlayOptions = {
      showTransitionOptions: '0ms linear',
      hideTransitionOptions: '0ms linear',
    };
  }

  public overrideValue() {
    this.onOverrideValue.emit();
  }
}
